import * as THREE from "three";


export default function light(scene){
    const ambientLight = new THREE.AmbientLight(0xffffff, 1.8);
    scene.add(ambientLight);

// Key light — основной, спереди сверху
    const keyLight = new THREE.DirectionalLight('#ffe8cc', 3.0);
    keyLight.position.set(5, 6, 5);
    keyLight.castShadow = true;
    keyLight.shadow.mapSize.width = 4096;
    keyLight.shadow.mapSize.height = 4096;
    keyLight.shadow.camera.near = 0.5;
    keyLight.shadow.camera.far = 50;
    keyLight.shadow.bias = -0.001;
    scene.add(keyLight);

// Fill light — слева спереди (у тебя уже есть, но убавь чуть)
    const fillLight = new THREE.DirectionalLight(0xffffff, 1.5);
    fillLight.position.set(-5, 3, 3);
    scene.add(fillLight);

// ✅ Back light — подсветка сзади, иначе задняя грань чёрная
    const backLight = new THREE.DirectionalLight(0xffffff, 1.2);
    backLight.position.set(0, 4, -6);
    scene.add(backLight);

// ✅ Rim light — контровый свет сбоку-сзади, добавляет объём
    const rimLight = new THREE.DirectionalLight('#ffd0a0', 0.8);
    rimLight.position.set(-4, 2, -4);
    scene.add(rimLight);
}